import { useState, useRef, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import api from "../../services/api";
import { etiquetaEtapaLead } from "../../utils/aplicarCompradorPipeline";

export default function BuscadorPipelineComprador({ onSeleccionar, isDark, tx = "#ffffff" }) {
  const [texto, setTexto] = useState("");
  const [resultados, setResultados] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [menuPos, setMenuPos] = useState(null);
  const timerRef = useRef(null);
  const inputRef = useRef(null);

  const inputSt = {
    padding: "3px 6px", borderRadius: 4, fontSize: 11, width: "100%",
    background: isDark ? "#1a2030" : "#fff",
    border: `1px solid ${isDark ? "#5a6a80" : "#c8c8be"}`,
    color: tx, outline: "none", fontFamily: "inherit",
  };

  const actualizarPosMenu = () => {
    const el = inputRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setMenuPos({ top: r.bottom + 3, left: r.left, width: Math.max(r.width, 280) });
  };

  useLayoutEffect(() => {
    if (!abierto) { setMenuPos(null); return; }
    actualizarPosMenu();
    const onScroll = () => actualizarPosMenu();
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("resize", onScroll);
    };
  }, [abierto, resultados.length, cargando]);

  const ejecutarBusqueda = async (q) => {
    setCargando(true);
    try {
      const r = await api.get(`/expedientes/pipeline-compradores?buscar=${encodeURIComponent(q)}`);
      setResultados(r.data?.data || []);
      setAbierto(true);
    } catch {
      setResultados([]);
      setAbierto(true);
    } finally {
      setCargando(false);
    }
  };

  const buscar = (q) => {
    setTexto(q);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => ejecutarBusqueda(q.trim()), 220);
  };

  const seleccionar = (lead) => {
    onSeleccionar(lead);
    setTexto("");
    setResultados([]);
    setAbierto(false);
  };

  const menu = abierto && menuPos && createPortal(
    <div
      style={{
        position: "fixed",
        top: menuPos.top,
        left: menuPos.left,
        width: menuPos.width,
        zIndex: 13000,
        background: isDark ? "#121820" : "#fff",
        border: `1px solid ${isDark ? "#5a6a80" : "#d1d5db"}`,
        borderRadius: 6,
        boxShadow: "0 12px 32px rgba(0,0,0,0.35)",
        maxHeight: 260,
        overflowY: "auto",
      }}
      onMouseDown={(e) => e.preventDefault()}
    >
      {cargando && (
        <div style={{ padding: "8px 10px", fontSize: 11, color: tx, opacity: 0.8 }}>Buscando...</div>
      )}
      {!cargando && resultados.length === 0 && (
        <div style={{ padding: "8px 10px", fontSize: 11, color: tx, opacity: 0.85 }}>
          {texto.trim() ? "Sin resultados en Pipeline (Ventas, Calientes, Visitantes…)" : "Escribe nombre, teléfono o ref."}
        </div>
      )}
      {!cargando && resultados.map((lead) => {
        const nom = [lead.cli_nombre || lead.nombre, lead.cli_apellido || lead.apellido].filter(Boolean).join(" ");
        const key = lead.lead_id || lead.cliente_id || nom;
        return (
          <div
            key={key}
            onMouseDown={() => seleccionar(lead)}
            style={{
              padding: "7px 10px", cursor: "pointer", fontSize: 11,
              borderBottom: `1px solid ${isDark ? "#374151" : "#f3f4f6"}`,
              color: tx,
            }}
          >
            <div style={{ fontWeight: 700 }}>{nom || "Sin nombre"}</div>
            <div style={{ fontSize: 10, opacity: 0.85, marginTop: 2 }}>
              {[etiquetaEtapaLead(lead.etapa), lead.propiedad_ref ? `Ref. ${lead.propiedad_ref}` : null, lead.telefono].filter(Boolean).join(" · ")}
            </div>
          </div>
        );
      })}
    </div>,
    document.body
  );

  return (
    <>
      <div style={{ position: "relative" }}>
        <input
          ref={inputRef}
          value={texto}
          onChange={(e) => buscar(e.target.value)}
          placeholder="Buscar comprador en Pipeline (nombre, teléfono, ref.)..."
          style={inputSt}
          onFocus={() => {
            if (!texto.trim() && !resultados.length) ejecutarBusqueda("");
            else if (resultados.length) setAbierto(true);
          }}
          onBlur={() => setTimeout(() => setAbierto(false), 200)}
        />
      </div>
      {menu}
    </>
  );
};
